<script setup>

import {router} from "@inertiajs/vue3";
import Button from "primevue/button";

defineProps({
    request: Object,
    borderless: Boolean
})

const emit = defineEmits(['close'])
</script>

<template>
    <div class="rounded-xl p-4" :class="!borderless ? 'bg-white dark:bg-neutral-900 mb-3 border dark:border-neutral-700' : ''">
        <div class="flex items-center gap-2">
            <!-- Typ žádosti -->
            <div class="flex items-center space-x-2 grow">
                <i :class="{
                    'pi pi-calendar-plus text-roori-blue': request.action === 'change',
                    'pi pi-calendar-times text-red-500': request.action === 'cancel'
                }" class="text-xl"></i>
                <p class="text-sm font-medium text-gray-700 dark:text-gray-100 text-nowrap">
                    {{ request.action === 'change' ? $t('reservations.request_type_change') : $t('reservations.request_type_cancel') }}
                </p>
            </div>
            <!-- Název rezervace -->
            <span class="text-sm font-semibold text-gray-900 dark:text-white mr-2">[{{ request?.reservations?.name }}]</span>

            <Button
                icon="pi pi-check"
                size="small"
                @click="() => {
                    router.visit(`/app/forms/request/${request.id}/accept`, { only: ['pendingChangeRequest'], preserveScroll: true, preserveState: true });
                    emit('close')
                }"
                outlined
                class="p-button-primary">
            </Button>
            <Button
                icon="pi pi-times"
                size="small"
                outlined
                @click="() => {
                    router.visit(`/app/forms/request/${request.id}/reject`, { only: ['pendingChangeRequest'], preserveScroll: true, preserveState: true });
                    emit('close')
                }"
                class="p-button-secondary">
            </Button>
        </div>

        <!-- Detaily změny s grafikou -->
        <div v-if="request.action === 'change'" class="flex items-center space-x-4 mt-4">
            <!-- Původní termín -->
            <div class="flex-1 text-center">
                <p class="text-sm font-medium text-gray-600 dark:text-gray-300">{{ $t('reservations.request_original') }}</p>
                <p class="text-sm font-semibold text-gray-800 dark:text-gray-400">
                    {{ request.reservations.formatted_date }}
                </p>
                <p class="text-sm text-gray-600 dark:text-gray-300">
                    {{ request.reservations.time_start.substring(0, 5) }}–{{ request.reservations.time_end.substring(0, 5) }}
                </p>
            </div>

            <!-- Šipka -->
            <i class="pi pi-arrow-right text-gray-400 text-2xl"></i>

            <!-- Nový termín -->
            <div class="flex-1 text-center">
                <p class="text-sm font-medium text-gray-600 dark:text-gray-300">{{ $t('reservations.request_new') }}</p>
                <p class="text-sm font-semibold text-gray-800 dark:text-gray-400">
                    {{ request.formatted_date }}
                </p>
                <p class="text-sm text-gray-600 dark:text-gray-300">
                    {{ request.new_time_start.substring(0, 5) }}–{{ request.new_time_end.substring(0, 5) }}
                </p>
            </div>
        </div>

        <!-- Tlačítka -->

    </div>
</template>

<style scoped lang="scss">

</style>
